<template>
  <v-select
    v-model="selectedId"
    :items="params.options"
    item-value="id"
    item-text="valueRenderer"
    :label="params.label"
    solo
    dense
    return-object
  >
    <template slot="selection" slot-scope="{ item }"> {{ item.valueRenderer }} </template>
    <template slot="item" slot-scope="{ item }"> {{ item.valueRenderer }} </template>
  </v-select>
</template>

<style lang="scss">
@import "comboboxComponent.scss";
</style>

<script type="text/javascript">
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      selectedElement: null
    };
  },

  computed: {
    selectedId: {
      // getter
      get: function() {
        if (this.params.value) {
          let selectedId = eval("this.params.value." + this.params.selectedId);
          return selectedId;
        } else return null;
      },
      // setter
      set: function(newValue) {
        let selectedElement;
        this.params.options.forEach(function(element) {
          if (element === newValue) {
            selectedElement = element.obj;
          }
        });
        this.selectedElement = selectedElement;
      }
    }
  },

  methods: {
    getValue() {
      // on renvoie le params.value modifié dans le setter
      return this.selectedElement;
    }
  },

  mounted() {
    // initialisation de l'objet selectioné
    this.selectedElement = this.params.value;
  }
});
</script>
